import { Products } from "./../../../../Views/ProductSelector/SubViews/Products";
// Libraries
import { action, computed, observable } from "mobx";

// Core
import { ModelBase } from "Core/Models/ModelBase";

// Custom
import { DelcoteProductsModel, DelcoteProductsModelDTO } from "./RoofSystemSubModels/DelcoteProducts";
import { SeamsilProductsModel, SeamsilProductsModelDTO } from "./RoofSystemSubModels/SeamsilProducts";
import { DelglazeModel, DelglazeModelDTO } from "./RoofSystemSubModels/Delglaze";
import { validate, ValidationError } from "class-validator";

export class RoofSystemModel extends ModelBase<RoofSystemModel, RoofSystemModelDTO> {
    private delcoteProductsModel: DelcoteProductsModel;
    private seamsilProductsModel: SeamsilProductsModel;
    private delglazeModel: DelglazeModel;

    constructor() {
        super();

        this.delcoteProductsModel = new DelcoteProductsModel();
        this.seamsilProductsModel = new SeamsilProductsModel();
        this.delglazeModel = new DelglazeModel();

        this.products.push({
            title:
                "Seamsil 100 cut edge corrosion system (<a href='https://www.hdsharman.co.uk/wp-content/uploads/2018/04/Seamsil-100-specification-v7-Feb22.pdf' target='_blank'>view system specification</a>)",
            value: "id_seamsil",
            guarantee: "Seamsil 100 cut edge corrosion system",
        });

        // Add the three delcote items in.
        this.products.push(...this.delcoteProductsModel.products);
        this.productSelection = this.products[0];
    }

    // #region Model Properties

    public get DelcoteProducts(): DelcoteProductsModel {
        return this.delcoteProductsModel;
    }

    public get SeamsilProducts(): SeamsilProductsModel {
        return this.seamsilProductsModel;
    }

    public get DelglazeModel(): DelglazeModel {
        return this.delglazeModel;
    }

    @observable
    public products = observable<any>([]);

    @observable
    private productSelection: any = undefined;

    @computed public get getProductSelection() {
        return this.productSelection;
    }

    @action
    public setProductSelection(value: any) {
        this.productSelection = value;
    }

    // #region Model Properties

    public fromDto(model: RoofSystemModelDTO): void {
        throw new Error("Method not implemented.");
    }

    public toDto(): RoofSystemModelDTO {
        return {
            delcoteProducts:
                this.productSelection.value === "id_delcotesubstratemetal10" ||
                this.productSelection.value === "id_delcotesubstratemetal25" ||
                this.productSelection.value === "id_delcotesubstratefibrecement"
                    ? this.DelcoteProducts.toDto()
                    : undefined,
            seamsilProducts: this.productSelection.value === "id_seamsil" ? this.SeamsilProducts.toDto() : undefined,
            delglaze: this.DelglazeModel.productRequired ? this.DelglazeModel.toDto() : undefined,
        };
    }

    public Validate = (): Promise<ValidationError[]> => {
        if (this.productSelection.value === "id_seamsil") {
            let promise = validate(this.SeamsilProducts.Seamsil100Model).then((errors) => {
                // errors is an array of validation errors
                let retVal: ValidationError[] = [];
                if (errors.length > 0) {
                    retVal = errors;
                    console.log("validation failed");
                } else {
                    console.log("validation succeed");
                }

                return retVal;
            });

            return promise;
        } else if (this.DelcoteProducts.getProductSelection.value === "id_delcotesubstratemetal25") {
            let promise = validate(this.DelcoteProducts.Delcote25Model).then((errors) => {
                // errors is an array of validation errors
                let retVal: ValidationError[] = [];
                if (errors.length > 0) {
                    retVal = errors;
                    console.log("validation failed");
                } else {
                    console.log("validation succeed");
                }

                return retVal;
            });

            return promise;
        } else if (this.DelcoteProducts.getProductSelection.value === "id_delcotesubstratemetal10") {
            let promise = validate(this.DelcoteProducts.Delcote10Model).then((errors) => {
                // errors is an array of validation errors
                let retVal: ValidationError[] = [];
                if (errors.length > 0) {
                    retVal = errors;
                    console.log("validation failed");
                } else {
                    console.log("validation succeed");
                }

                return retVal;
            });

            return promise;
        } else {
            //if (this.DelcoteProducts.productSelection.value === "id_delcotesubstratefibrecement") {
            let promise = validate(this.DelcoteProducts.DelcoteAsbestosModel).then((errors) => {
                // errors is an array of validation errors
                let retVal: ValidationError[] = [];
                if (errors.length > 0) {
                    retVal = errors;
                    console.log("validation failed");
                } else {
                    console.log("validation succeed");
                }

                return retVal;
            });

            return promise;
        }
    };
}

export interface RoofSystemModelDTO {
    delcoteProducts?: DelcoteProductsModelDTO;
    seamsilProducts?: SeamsilProductsModelDTO;
    delglaze?: DelglazeModelDTO;
}
